// import store from '@/store'
// import _ from 'lodash'

export default {
  getSunIcon () {
    return { icon: 'mdi-weather-sunny', color: 'orange', text: 'Sunny' }
  },
  getSnowIcon () {
    return { icon: 'mdi-snowflake', color: 'info', text: 'Snow' }
  },
  getCloudIcon () {
    return { icon: 'mdi-cloud-outline', color: 'blue-grey', text: 'Cloudy' }
  },
  getWeatherData (log) {
    // Based on the log's weather selection, return the appropriate icon, with color
    // -- Return:
    //    { icon: 'mdi----', color: 'color' }
    let val = { icon: 'mdi-question', color: 'grey lighten-2', text: 'No weather data set' }
    if (log) {
      if (log.is_sunny) {
        val.icon = this.getSunIcon().icon
        val.color = this.getSunIcon().color
        val.text = this.getSunIcon().text
      } else if (log.is_snowing) {
        val.icon = this.getSnowIcon().icon
        val.color = this.getSnowIcon().color
        val.text = this.getSnowIcon().text
      } else if (log.is_cloudy) {
        val.icon = this.getCloudIcon().icon
        val.color = this.getCloudIcon().color
        val.text = this.getCloudIcon().text
      }
    }
    return val
  },
  getWeatherText (log) {
    // Based on the log's weather selection, return the text to show
    let val = 'No weather set...'
    console.log(log)
    console.log(log.is_sunny)
    if (log) {
      if (log.is_sunny) {
        val = 'Sunny'
      } else if (log.is_snowing) {
        val = 'Snowing'
      } else if (log.is_cloudy) {
        val = 'Cloudy'
      }
    }
    return val
  },
  getSnowAmountText (log) {
    // Based on the log's weather selection, return the text to show
    if (log.is_sunny || log.is_cloudy) {
      return ''
    }
    let val = '0cm'
    if (log) {
      if (log.snow_amount === 0) {
        val = 'None'
      } else if (log.snow_amount === 2) {
        val = 'Under 2cm'
      } else if (log.snow_amount === 4) {
        val = '2-6cm'
      } else if (log.snow_amount === 6) {
        val = 'Over 6cm'
      }
    }
    return val
  },
  getCrewStatus (log) {
    // Based on the log's weather selection, return the text to show
    let val = { text: 'Crews did not go out', icon: 'mdi-truck', color: 'red' }
    if (log) {
      if (log.send_crews) {
        val = { text: 'Crews went out', icon: 'mdi-truck-fast', color: 'success' }
      }
    }
    return val
  }
}

// { value: 'snow', text: 'Snow', icon: 'mdi-snowflake', color: 'info' },
// { value: 'sun', text: 'Sunny', icon: 'mdi-weather-sunny', color: 'orange' },
// { value: 'clouds', text: 'Clouds', icon: 'mdi-cloud-outline', color: 'blue-grey' },
